// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 768px) and (max-width: 1023px) {
  .single_article_top_details_wrapper {
    width: 95%;
    display: flex !important;
    flex-direction: column-reverse !important;
    gap: 5%;
  }

  .single_article_second_column_container {
    width: 100%;
    padding-top: 8%;
  }
  .single_article_top_icons_container {
    display: none !important;
  }
  .single_article_first_column_container {
    width: 100% !important;
  }
  .single_article_writer_details {
    display: flex;
    align-items: center;
  }
  .single_article_view_and_reading_time {
    display: none;
  }
  .writer_name {
    font-size: 18px;
  }
  .published_date {
    font-size: 18px;
  }

  .single_article_first_column_title {
    color: var(--background-theme-color);
    font-size: 22px;
  }
  .single_article_back_ground_container {
    height: 45% !important;
  }
  .report_share_second_column_container {
    width: 10%;
  }
  .report_share_container {
    padding: 5% 0 5% 0;
    width: 100%;
  }
  .single_article_donation_conatiner {
    display: none;
  }
  .single_article_content_container {
    width: 100% !important;
    gap: 30px;
  }
  .single_article_donation_container {
    display: none;
  }
  .report_container {
    display: none;
  }
  .whatsapp_gif_icon_container {
    width: 15%;
  }
  .whatsapp_channel_content {
    font-size: 20px;
  }
  .writer_profile_image {
    width: 80px !important;
    height: 80px !important;
  }
  .single_article_details_with_donation_wrapper {
    padding: 4% 0 3% 0 !important;
  }
  .single_article_first_column_title_ta {
    color: var(--background-theme-color);
    font-size: 22px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_768_1023/screen_768_1023_single_article.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;IACV,wBAAwB;IACxB,yCAAyC;IACzC,OAAO;EACT;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oCAAoC;IACpC,eAAe;EACjB;AACF","sourcesContent":["@media only screen and (min-width: 768px) and (max-width: 1023px) {\n  .single_article_top_details_wrapper {\n    width: 95%;\n    display: flex !important;\n    flex-direction: column-reverse !important;\n    gap: 5%;\n  }\n\n  .single_article_second_column_container {\n    width: 100%;\n    padding-top: 8%;\n  }\n  .single_article_top_icons_container {\n    display: none !important;\n  }\n  .single_article_first_column_container {\n    width: 100% !important;\n  }\n  .single_article_writer_details {\n    display: flex;\n    align-items: center;\n  }\n  .single_article_view_and_reading_time {\n    display: none;\n  }\n  .writer_name {\n    font-size: 18px;\n  }\n  .published_date {\n    font-size: 18px;\n  }\n\n  .single_article_first_column_title {\n    color: var(--background-theme-color);\n    font-size: 22px;\n  }\n  .single_article_back_ground_container {\n    height: 45% !important;\n  }\n  .report_share_second_column_container {\n    width: 10%;\n  }\n  .report_share_container {\n    padding: 5% 0 5% 0;\n    width: 100%;\n  }\n  .single_article_donation_conatiner {\n    display: none;\n  }\n  .single_article_content_container {\n    width: 100% !important;\n    gap: 30px;\n  }\n  .single_article_donation_container {\n    display: none;\n  }\n  .report_container {\n    display: none;\n  }\n  .whatsapp_gif_icon_container {\n    width: 15%;\n  }\n  .whatsapp_channel_content {\n    font-size: 20px;\n  }\n  .writer_profile_image {\n    width: 80px !important;\n    height: 80px !important;\n  }\n  .single_article_details_with_donation_wrapper {\n    padding: 4% 0 3% 0 !important;\n  }\n  .single_article_first_column_title_ta {\n    color: var(--background-theme-color);\n    font-size: 22px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
